import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  Checkbox,
  TablePagination,
  CircularProgress,
  Box,
  Modal,
} from "@mui/material";
import { Eye, Pencil, Trash2, AlertTriangle } from "lucide-react";
import { NavLink } from "react-router-dom";
import { infoToast } from "../../../../../services/toast.service";

export const defaultColumns = [
  { id: "photo", label: "", minWidth: "100px", required: true },
  { id: "name", label: "Name", minWidth: "200px", required: true },
  { id: "colors", label: "Colours", minWidth: "180px", required: true },
  { id: "unit", label: "Unit", minWidth: "120px", required: true },
  { id: "quantity", label: "Quantity", minWidth: "120px", required: true },
  {
    id: "avgPrice",
    label: "Avg Price/Unit",
    minWidth: "140px",
    required: true,
  },
  { id: "action", label: "Action", minWidth: "120px", required: true },
];

// Dummy data for clothing materials
export const dummyMaterials = [
  {
    id: 1,
    name: "Cotton Fabric",
    colors: "White, Black, Navy Blue, Grey",
    unit: "meters",
    quantity: 1500,
    avgPrice: 180,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 2,
    name: "Silk",
    colors: "Red, Gold, Royal Blue, Emerald Green",
    unit: "meters",
    quantity: 800,
    avgPrice: 950,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 3,
    name: "Denim",
    colors: "Light Blue, Dark Blue, Black",
    unit: "meters",
    quantity: 2000,
    avgPrice: 250,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 4,
    name: "Linen",
    colors: "White, Beige, Light Grey",
    unit: "meters",
    quantity: 1200,
    avgPrice: 450,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 5,
    name: "Buttons",
    colors: "Silver, Gold, Black, White",
    unit: "pieces",
    quantity: 5000,
    avgPrice: 5,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 6,
    name: "Zippers",
    colors: "Black, White, Brown",
    unit: "pieces",
    quantity: 3000,
    avgPrice: 15,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 7,
    name: "Wool Blend",
    colors: "Grey, Navy, Maroon, Black",
    unit: "meters",
    quantity: 600,
    avgPrice: 750,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 8,
    name: "Elastic Band",
    colors: "White, Black",
    unit: "meters",
    quantity: 4000,
    avgPrice: 8,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 9,
    name: "Thread Spools",
    colors: "All Colors Available",
    unit: "pieces",
    quantity: 8000,
    avgPrice: 25,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 10,
    name: "Polyester Fabric",
    colors: "White, Black, Red, Blue, Green",
    unit: "meters",
    quantity: 2500,
    avgPrice: 120,
    photo:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 0,
};

const DeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  material,
  isLoading,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <div className="p-6">
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-4">
              <AlertTriangle className="w-6 h-6 text-red-500" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Delete Material
            </h3>
            <p className="text-sm text-gray-500 mb-4">
              Are you sure you want to delete the material "{material?.name}"?
            </p>

            {/* Impact Information */}
            <div className="p-3 rounded-lg text-sm mb-4 bg-red-50 text-red-600">
              <p className="font-medium mb-1">Impact of Deletion:</p>
              <ul className="text-left space-y-1">
                <li>• Material will be permanently removed from the system</li>
                <li>• All associated stock entries will be deleted</li>
                <li>• This action cannot be undone</li>
                <li className="font-medium mt-2">
                  ⚠️ This material has stock entries that will be affected
                </li>
              </ul>
            </div>

            <div className="flex gap-3">
              <button
                onClick={onClose}
                disabled={isLoading}
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50">
                Cancel
              </button>
              <button
                onClick={onConfirm}
                disabled={isLoading}
                className="px-4 py-2 text-white rounded-lg text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 bg-red-600 hover:bg-red-700">
                {isLoading ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    Deleting...
                  </>
                ) : (
                  "Delete Material"
                )}
              </button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

const MaterialTable = ({
  onSettingsClick,
  anchorEl,
  onCloseSettings,
  visibleColumns,
  onColumnToggle,
  setRefetchFn,
  searchQuery,
  filters,
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isLoading, setIsLoading] = React.useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const [materialToDelete, setMaterialToDelete] = React.useState(null);
  const [isDeleting, setIsDeleting] = React.useState(false);

  // Filter materials based on search query and filters
  const filteredMaterials = dummyMaterials.filter(material => {
    const matchesSearch = searchQuery
      ? material.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        material.colors.toLowerCase().includes(searchQuery.toLowerCase())
      : true;

    const matchesUnit = filters.unit ? material.unit === filters.unit : true;

    return matchesSearch && matchesUnit;
  });

  // Sort materials based on sortBy filter
  const sortedMaterials = [...filteredMaterials].sort((a, b) => {
    switch (filters.sortBy) {
      case "name_asc":
        return a.name.localeCompare(b.name);
      case "name_desc":
        return b.name.localeCompare(a.name);
      case "quantity_asc":
        return a.quantity - b.quantity;
      case "quantity_desc":
        return b.quantity - a.quantity;
      case "price_asc":
        return a.avgPrice - b.avgPrice;
      case "price_desc":
        return b.avgPrice - a.avgPrice;
      default:
        return 0;
    }
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleDeleteClick = material => {
    setMaterialToDelete(material);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!materialToDelete) return;

    setIsDeleting(true);
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Remove material from dummy data (in real app, this would be an API call)
      const index = dummyMaterials.findIndex(m => m.id === materialToDelete.id);
      if (index > -1) {
        dummyMaterials.splice(index, 1);
      }

      infoToast("Material deleted successfully");
      setDeleteModalOpen(false);
      setMaterialToDelete(null);
    } catch (error) {
      infoToast("Failed to delete material");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setMaterialToDelete(null);
  };

  // Filter visible columns
  const visibleColumnsList = defaultColumns.filter(
    column => visibleColumns[column.id],
  );

  return (
    <Paper
      sx={{
        width: "100%",
        overflow: "hidden",
        boxShadow: "none",
        border: "1px solid #E5E7EB",
        borderRadius: "0.5rem",
      }}>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onCloseSettings}
        PaperProps={{
          style: {
            maxHeight: 300,
            width: 200,
          },
        }}>
        <div className="px-3 py-2 border-b border-gray-100">
          <p className="text-sm font-medium text-gray-600">Show Columns</p>
        </div>
        {defaultColumns.map(column => (
          <MenuItem
            key={column.id}
            onClick={() => onColumnToggle(column.id)}
            disabled={column.required}
            dense>
            <Checkbox
              checked={visibleColumns[column.id]}
              disabled={column.required}
              size="small"
              sx={{
                color: "#5652B0",
                "&.Mui-checked": {
                  color: "#5652B0",
                },
              }}
            />
            <span
              className={`text-sm ${column.required ? "text-gray-400" : ""}`}>
              {column.label}
              {column.required && " *"}
            </span>
          </MenuItem>
        ))}
      </Menu>

      <TableContainer
        sx={{
          maxHeight: "calc(100vh - 300px)",
          overflow: "auto",
          "&::-webkit-scrollbar": {
            height: "8px",
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#F3F4F6",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#D1D5DB",
            borderRadius: "4px",
          },
        }}
        className="scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-50">
        <Table stickyHeader sx={{ minWidth: 1000 }} aria-label="sticky table">
          <TableHead>
            <TableRow>
              {visibleColumnsList.map(column => (
                <TableCell
                  key={column.id}
                  align="center"
                  sx={{
                    minWidth: column.minWidth,
                    backgroundColor: "#F9FAFB",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#374151",
                    borderBottom: "2px solid #E5E7EB",
                  }}
                  className="font-outfit">
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={visibleColumnsList.length} align="center">
                  <div className="flex items-center justify-center py-4">
                    <CircularProgress size={40} />
                  </div>
                </TableCell>
              </TableRow>
            ) : sortedMaterials.length === 0 ? (
              <TableRow>
                <TableCell colSpan={visibleColumnsList.length} align="center">
                  <div className="py-4 text-gray-500">No materials found</div>
                </TableCell>
              </TableRow>
            ) : (
              sortedMaterials
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(material => (
                  <TableRow
                    hover
                    key={material.id}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#F9FAFB",
                      },
                    }}>
                    {visibleColumnsList.map(column => (
                      <TableCell
                        key={column.id}
                        align="center"
                        sx={{
                          padding: "12px 16px",
                          fontSize: "14px",
                          color: "#4B5563",
                        }}
                        className="font-outfit">
                        {column.id === "photo" ? (
                          <img
                            src={material[column.id]}
                            alt={material.name}
                            className="w-12 h-12 object-cover rounded-lg mx-auto"
                          />
                        ) : column.id === "avgPrice" ? (
                          `₹${material[column.id]}`
                        ) : column.id === "action" ? (
                          <div className="flex items-center justify-center gap-2">
                            <NavLink
                              to={`/production/materials/view/${material.id}`}
                              className="p-1.5 rounded-md bg-purple-50 hover:bg-purple-100 transition-colors"
                              title="View Material">
                              <Eye size={16} className="text-[#5652B0]" />
                            </NavLink>
                            <button
                              onClick={() => handleDeleteClick(material)}
                              className="p-1.5 rounded-md bg-red-50 hover:bg-red-100 transition-colors"
                              title="Delete Material">
                              <Trash2 size={16} className="text-red-500" />
                            </button>
                          </div>
                        ) : (
                          material[column.id]
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={sortedMaterials.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{
          borderTop: "1px solid #E5E7EB",
          ".MuiTablePagination-select": {
            borderRadius: "0.375rem",
          },
        }}
      />
      <DeleteConfirmationModal
        open={deleteModalOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        material={materialToDelete}
        isLoading={isDeleting}
      />
    </Paper>
  );
};

export default MaterialTable;
